<template>
  <d2-container>
    <div class="solutions">
      <div class="solutionsbanner">
        <div class="solutionsbasecont">
          <h3>算力城市融合云解决方案</h3>
          <h4>面向丰富的业务场景，提供整套行业和技术解决方案，主力客户安全高效上云。</h4>
        </div>
      </div>
      <div class="solutionsbasecont">
        <div class="solutionsSection1">
          <h2>热门行业解决方案</h2>
          <img src="/image/portalimg/solution/solutionsSetion1.png">
        </div>
      </div>
      <div class="solutionsbasecont">
        <div class="solutionsSection2">
          <h2>方案与架构</h2>
          <div class="solutionsSection2Cont">
            <h4>方案与架构咨询</h4>
            <p>关于使用场景和技术架构的更多咨询，请联系我们的销售和技术支持团队。</p>
          </div>
          <button class="contactBtn" @click="goToSptResources"></button>
        </div>
      </div>

      <base-bottom></base-bottom>
    </div>
  </d2-container>
</template>

<script>
import baseBottom from '../components/base-bottom'

export default {
  name: 'solutions',
  components: {
    baseBottom
  },
  data() {
    return {}
  },
  methods: {
    goToSptResources() {
      this.$router.push({
        path: '/sptResources',
      });
    }
  },
}
</script>

<style scoped>
*, body, html {
  margin: 0;
  padding: 0;
  width: 100%;
}

.lf {
  float: left;
}

.rf {
  float: right;
}

@media (min-width: 769px) {
    /* PC端样式 */

.solutionsbanner {
  background: url(/image/portalimg/solution/banner.png) no-repeat center center;
  height: auto;
}

.solutionsbasecont {
  width: 1560px;
  margin: 0 auto;
  overflow: hidden;
  padding-left: 60px;
}

.solutionsbasecont h3 {
  padding-top: 220px;
  padding-bottom: 35px;
  font-size: 42px;
  letter-spacing: 4.2px;
  text-align: left;
  line-height: 51px;
  font-weight: 400;
  color: #fff;
}

.solutionsbasecont h4 {
  color: #fff;
  font-size: 20px;
  text-align: left;
  letter-spacing: 4.2px;
  font-weight: 400;
  padding-bottom: 193px;
}

.solutionsSection1 h2 {
  font-size: 38px;
  color: #000000;
  letter-spacing: 4px;
  text-align: center;
  font-weight: 600;
  padding: 120px 0 60px;
}

.solutionsSection2 {
  padding-bottom: 86px;
  position: relative;
}

.solutionsSection2 h2 {
  font-size: 38px;
  color: #000000;
  letter-spacing: 4px;
  text-align: center;
  font-weight: 600;
  padding: 110px 0 60px;
}
.contactBtn{
  position: absolute;
  width: 160px;
  height: 60px;
  bottom: 252px;
  right: 20px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0);
  border: 0;
}

.solutionsSection2Cont {
  height: 296px;
  background: url(/image/portalimg/solution/solutionsSetion2.png) no-repeat center center;
  padding-left: 40px;
}

.solutionsSection2Cont h4 {
  font-size: 32px;
  color: #FFFFFF;
  letter-spacing: 4px;
  font-weight: 500;
  padding: 49px 0 20px;
}

.solutionsSection2Cont p {
  color: #fff;
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 2.25px;
  font-weight: 500;
}

}

@media (max-width: 768px) {
    /* 移动端样式 */

    .solutionsbanner {
      background: url(/image/portalimg/solution/banner.png) no-repeat center center;
      height: auto;
      background-size: 100% 100%;
    }

    .solutionsbasecont {
      width: 100%;
      margin: 0 auto;
      overflow: hidden;
    }

    .solutionsbasecont h3 {
        padding-top: 85px;
        padding-bottom: 5px;
        font-size: 18px;
        letter-spacing: 3px;
        text-align: center;
        line-height: 30px;
        font-weight: 400;
        color: #fff;
    }

    .solutionsbasecont h4 {
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        letter-spacing: 2.5px;
        font-weight: 400;
        padding-bottom: 30px;
        width: 84%;
        margin: 0 8%;
    }

    .solutionsSection1 h2 {
      font-size: 20px;
      color: #000000;
      letter-spacing: 4px;
      text-align: center;
      font-weight: 600;
      padding: 30px 0 20px;
    }

    .solutionsSection2 {
      padding-bottom: 40px;
      position: relative;
    }

    .solutionsSection2 h2 {
      font-size: 20px;
      color: #000000;
      letter-spacing: 4px;
      text-align: center;
      font-weight: 600;
      padding: 30px 0 20px;
    }

    .solutionsSection2Cont {
      background: url(/image/portalimg/solution/solutionsSetion2.png) no-repeat center center;
      background-size: 100% 100%;
      height: 93px;
      width: 90%;
      margin: 0 5%;
    }

    .solutionsSection2Cont h4 {
      font-size: 13px;
      color: #FFFFFF;
      letter-spacing: 4px;
      font-weight: 500;
      padding: 15px 0 6px;
      margin-left: 5%;
    }

    .solutionsSection2Cont p {
      font-size: 8px;
      color: #FFFFFF;
      /* letter-spacing: 2px; */
      font-weight: 500;
      width: 72%;
      padding-left: 5%;
    }
    .contactBtn{
      position: absolute;
      width: 12%;
      height: 23px;
      bottom: 89px;
      right: 7%;
      cursor: pointer;
      background: rgba(0, 0, 0, 0);
      border: 0;
    }
}
</style>
